<template>
<div class="bande" id="6" >

  <!-- DESKTOP --> 
   <div class="columns" style="margin-top:7%; ">
      <div class="column is-one-third is-hidden-mobile" style="background-color:  #583D6A; color:white;   padding-top:5%;"> 
        <h1 class="is-size-3"> MENTIONS LEGALES </h1>
        <h2> Pourquoi des Mentions légales ? </h2>
        <div  class="is-size-5" style="color:white; margin-top:7%; float:left; margin-left:8%; margin-right:15%; text-align:justify;font-family: 'Spartan', sans-serif; ">
       Les mentions légales sont obligatoires et permettent à tout visiteur d'obtenir des informations, 
       concernant l'identité de l'entreprise ou encore l'utilisation de nos données.
        </div>
        <div class="blanc"> </div>
        <div class="blancBis"> </div>
      </div>
       <!--MOBILE-->
      <h1 class="is-size-4 is-hidden-desktop" style="padding-top:25%; padding-bottom:10%; margin-right:auto; margin-left:auto; display:block;"> MENTIONS LEGALES </h1>
      <div class="column " style="padding-top:5%;"> 
      <p class="title is-size-4-desktop is-size-6-mobile" style="margin-top: 5%;">IDENTIFICATION</p>
      <ul style=" margin-top: 3%;">
        <li>Dénomination sociale : FOBWARE SI </li>
        <li>Adresse du siège social :  15 RUE LAMORICIERE 44100 NANTES</li>
        <li>Numéro de téléphone :  09 72 32 43 57</li>
        <li>Courrier électronique :  contact@fobware.com </li>
        <li>Montant du capital social :  32 000,00 €</li>
        <li>Directeur : 	M. Côme VINÇOTTE </li>
        <li>Nom, dénomination de l'hébergeur :  [Nom, dénomination de l'hébergeur] </li>
        <li>Adresse et numéro de téléphone de l'hébergeur :  [Adresse et numéro de téléphone de l'hébergeur]</li>
      </ul>
      <p class="title is-size-4  is-size-6-mobile" style="margin-top: 5%;">ACTIVITE</p>
      
      <ul style="margin-top:3%; ">
        <li>Numéro d'inscription au registre du commerce et des sociétés :  Nantes B 750 233 389 </li>
        <li>Numéro individuel d'identification fiscale : FR61750233389</li>
        <li>Conditions générales de vente : [Conditions générales de vente]</li>
      </ul>

      <p class="title is-size-4 is-size-6-mobile" style="margin-top: 5%;">UTILISATION DES DONNEES PERSONNELLE </p>

      <ul style="margin-top: 3%; ">
        <li>Coordonnées du délégué à la protection des données : [ ]</li>
        <li>Finalité poursuivie par le traitement auquel les données sont destinées : [ ]</li>
        <li>Caractère obligatoire ou facultatif des réponses et conséquences éventuelles à l'égard de l'internaute d'un défaut de réponse : [ ]</li>
        <li>Destinataires ou catégories de destinataires des données : [ ]</li>
        <li>Droits d'opposition, d'interrogation, d'accès et de rectification : [ ]</li>
        <li>Au besoin, les transferts de données à caractère personnel envisagés à destination d'un État n'appartenant pas à l'Union européenne : [ ]</li>
        <li>Base juridique du traitement de données  : [ ]</li>
        <li>Mention du droit d'introduire une réclamation (plainte) auprès de la Cnil : [ ]</li>
      </ul>

      <p class="title is-size-4  is-size-6-mobile" style="margin-top: 5%;">AUTEURS CREDITES </p>
    
      <ul style="margin-top: 3%;  margin-bottom:5%; ">
        <li>Toutes les icones du site viennent de  : <a  href="https://icones8.fr/" Style="color:darkslategray;">ICONS8</a> </li>
        <li>Image d'acceuil  : <a  href="https://creativecommons.org/licenses/by-sa/2.0/" Style="color:darkslategray;"> Voir les droits reservés - Ajout d'un filtre violet sur l'image </a> </li>
      </ul>
       </div>
   </div>
    <hr style=" border : 0.5px solid #482A5C; margin-top:-0.6%;margin-bottom:2%">
    <a ><span  v-on:click="scrollFix('#6')"><router-link to="/notice"> <p class="MentionsLegale">Mentions légales © 2021 par FOBware SI </p> </router-link></span></a>
  </div>


</template>

<script>

export default {
  name: "NoticePage",
  methods: {
    scrollFix: function(hashbang)
    {
      location.hash = hashbang;
    }
  }
};
</script>
<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@200&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Lato&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Courier+Prime&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Coustard&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Spartan:wght@600&display=swap');

.blanc{
  width:135%;
  height: 3%;
  background-color: #FAFAFA;
  margin-top:75%;
  position:relative;
  float: left;
  margin-left:-30%;
  transform: rotate(30deg);
}
.blancBis{
  width:80%;
  height: 3%;
  background-color: #FAFAFA;
  margin-top:5.5%;
  position:relative;
  float: left;
  margin-left:-30%;
  transform: rotate(30deg);
}
h2{
 margin-top:17%;
 float:left; 
 margin-left:8%; 
 font-family: 'Courier Prime', monospace;
 font-size: 26px;
}

.MentionsLegale{
text-align:center;
margin-bottom:2%;
}

.bande{
  background-color: #FAFAFA;

}
.banderole{
  margin-top:8%;
  background-color: #583D6A;


  width:100%;
}
.all{
  margin-top:5%;

}
h1{
  text-align: center;
  margin-top:10%;
  font-family: 'Courier Prime', monospace;
  color:black;
  background-color:  #FAFAFA;
  width: 70%;
  padding-top:1%;
  padding-bottom:1%;
}
p{
  text-align: left;
  margin-left:12%;
  color:#583D6A;
   font-family: 'Montserrat', sans-serif;
   font-weight: bold;
}
ul li{
  text-align:left;
  margin-left:12%;
  margin-right:12%;
  font-family: 'Lato', sans-serif;
}

</style>